export default __webpack_public_path__ + "static/media/boneshatter.1e92a64d.png";